import React, { useEffect, useState } from "react";
import "../styles/GiftAnimation.css";

function GiftAnimation() {
  const [gift, setGift] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      setGift(event.detail);

      // Auto hide après 1.2s
      setTimeout(() => {
        setGift(null);
      }, 1200);
    };

    window.addEventListener("gift-animation", handler);

    return () => {
      window.removeEventListener("gift-animation", handler);
    };
  }, []);

  if (!gift) return null;

  return (
    <div className="gift-animation-overlay">
      <div className="gift-animation-content">
        <img src={gift.image} alt={gift.name} />
        <div className="gift-animation-name">{gift.name}</div>
      </div>
    </div>
  );
}

export default GiftAnimation;
